import React from 'react';
import './CSS/policy.css';

const RefundPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>REFUND & CANCELLATION POLICY – Sri Sairam Advertising</h1>
                <p className="effective-date">Effective Date: 23 April 2026</p>
                
                <p>
                    Sri Sairam Advertising, Chennai, Tamil Nadu, provides newspaper advertising, digital advertising, ad design, campaign management, bulk SMS/WhatsApp promotions, and related services.
                </p>
                <p>
                    By booking any service with Sri Sairam Advertising, you acknowledge that you have read, understood, and agreed to this Refund & Cancellation Policy.
                </p>

                <hr />

                <section>
                    <h2>1. General Policy</h2>
                    <p>
                        All payments made to Sri Sairam Advertising for advertisement booking, ad design, campaign management, digital promotions, newspaper publication, bulk SMS, WhatsApp campaigns, and related services are subject to this policy.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>2. No Refund After Ad Release</h2>
                    <p>No refund will be provided once:</p>
                    <ul>
                        <li>An advertisement has been submitted, scheduled, released, or published in any newspaper or print media</li>
                        <li>A digital advertising campaign has been activated on Google, Facebook, Instagram, or any other platform</li>
                        <li>Ad budget has been spent, either fully or partially</li>
                    </ul>
                    <p>Once the service enters execution or media delivery, the amount becomes non-refundable.</p>
                    <p>Any platform-related refunds (if applicable) are governed by the respective platform’s policies.</p>
                </section>

                <hr />

                <section>
                    <h2>3. Cancellation Before Release</h2>
                    <p>Cancellation requests will be considered only if made before:</p>
                    <ul>
                        <li>The newspaper booking deadline</li>
                        <li>The campaign goes live</li>
                        <li>Any third-party cost is incurred</li>
                    </ul>
                    <p>If cancellation is approved, a refund may be processed after deducting:</p>
                    <ul>
                        <li>Design or creative charges</li>
                        <li>Campaign setup charges</li>
                        <li>Payment gateway charges</li>
                        <li>Administrative or service charges</li>
                        <li>Amounts already committed to vendors, publishers, or platforms</li>
                    </ul>
                    <p>The final refundable amount (if any) will depend on the work completed and costs incurred.</p>
                </section>

                <hr />

                <section>
                    <h2>4. Digital Advertising</h2>
                    <p>For Google Ads, Facebook Ads, Instagram Ads, and similar platforms:</p>
                    <ul>
                        <li>We do not guarantee leads, calls, inquiries, conversions, or sales</li>
                        <li>Performance depends on market conditions, competition, audience behavior, targeting, budget, and platform algorithms</li>
                        <li>Once ad spend is used, it is non-refundable</li>
                    </ul>
                    <p>Refunds related to platform balances (if any) depend entirely on the platform’s policies.</p>
                </section>

                <hr />

                <section>
                    <h2>5. Client Responsibility & Errors</h2>
                    <p>No refund or compensation will be provided for issues arising from:</p>
                    <ul>
                        <li>Incorrect details provided by the client</li>
                        <li>Errors approved by the client</li>
                        <li>Delay in approval, payment, or communication</li>
                        <li>Change of mind after confirmation</li>
                        <li>Platform or publisher rejection due to policy violations</li>
                    </ul>
                    <p>Clients must review all ad content carefully before approval.</p>
                </section>

                <hr />

                <section>
                    <h2>6. Non-Refundable Services</h2>
                    <p>The following are generally non-refundable once work has started:</p>
                    <ul>
                        <li>Newspaper ad booking charges</li>
                        <li>Ad design and creative charges</li>
                        <li>Campaign setup and consultation fees</li>
                        <li>Bulk SMS / WhatsApp campaign execution charges</li>
                        <li>Urgent or priority processing fees</li>
                        <li>Third-party media spend</li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>7. Refund Processing</h2>
                    <p>If a refund is approved, it will be processed within 5–10 working days to the original payment method.</p>
                    <p>Actual credit time may vary based on the bank or payment provider.</p>
                </section>

                <hr />

                <section>
                    <h2>8. Disputes & Jurisdiction</h2>
                    <p>All disputes related to services, payments, cancellations, or refunds shall be subject to the exclusive jurisdiction of Chennai, Tamil Nadu.</p>
                </section>

                <hr />

                <section>
                    <h2>9. Force Majeure</h2>
                    <p>Sri Sairam Advertising shall not be responsible for delays or service issues caused by events beyond reasonable control, including technical failures, platform downtime, government restrictions, or natural events.</p>
                </section>

                <hr />

                <section>
                    <h2>10. Policy Updates</h2>
                    <p>Sri Sairam Advertising may update this policy at any time without prior notice. Updated versions will be posted on our website.</p>
                </section>

                <hr />

                <section>
                    <h2>11. Contact Us</h2>
                    <div className="contact-info">
                        <p><strong>Sri Sairam Advertising</strong></p>
                        <p>Chennai, Tamil Nadu, India</p>
                        <p>📞 +91 9500037429</p>
                        <p>✉️ info@srisairamadvertising.com</p>
                        <p>🌐 <a href="https://srisairamadvertising.com/">https://srisairamadvertising.com/</a></p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default RefundPolicy;
